import { TaskCompletion as Task } from '@sparx/api/apis/sparx/packages/v1/spxpkg';

export const isTimesTablesTask = (task: Task) => task.taskType === 'GAME';
export const isVideoTask = (task: Task) => task.taskType === 'VIDEO';
export const isFTQTask = (task: Task) => task.taskType === 'FAST_TRACK_QUIZ';
